module.exports = __webpack_public_path__ + "img/multiplier.c8634fb1.png";